import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface IStatusPill {
  status: string;
}

const StatusPill = ({ status }: IStatusPill) => {
  const { t } = useTranslation();

  const currentStatus = {
    SUCCESS: {
      text: t("lbl_cash_out_completed"),
      style: "success",
    },
    TRANSFERRED: {
      text: t("lbl_cash_out_completed"),
      style: "success",
    },
    PENDING: {
      text: t("lbl_pending_cash_out"),
      style: "pending",
    },
    PENDING_TRANSFER: {
      text: t("lbl_not_cashed_out"),
      style: "not_sent",
    },
    FAILED: {
      text: t("lbl_cash_out_failed"),
      style: "failed",
    },
    NOT_SENT: {
      text: t("lbl_not_cashed_out"),
      style: "not_sent",
    },
    // Withdraws statuses mapped to the same visuals/text with pending as is
    COMPLETED: {
      text: t("lbl_cash_out_completed"),
      style: "success",
    },
    IN_PROGRESS: {
      text: t("lbl_not_cashed_out"),
      style: "not_sent",
    },
    AVAILABLE_BALANCE: {
      text: t("lbl_added_to_wallet"),
      style: "success",
    },
    INITIATED: {
      text: t("lbl_not_cashed_out"),
      style: "not_sent",
    },
  };

  return (
    <div
      className={classNames(
        styles.pill,
        styles[(currentStatus[status] || currentStatus["NOT_SENT"]).style]
      )}>
      {(currentStatus[status] || currentStatus["NOT_SENT"]).text}
    </div>
  );
};

export default StatusPill;
